import { Component, ViewEncapsulation } from '@angular/core';
import {RouterOutlet} from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-layout-public',
	imports: [
		RouterOutlet,
		CommonModule
	],
    templateUrl: './public.component.html',
    styleUrl: './public.component.scss',
    encapsulation: ViewEncapsulation.None,
    // fill <main>, so the login box stays centred on the screen
    host: {
        class: 'flex flex-1',
    },
})
export class LayoutPublicComponent {}
